/**
* @description: 物料申购新增
* @author: niuzijie
*/
<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :show-close='false' :modal-append-to-body='true'
      :close-on-click-modal="false" :close-on-press-escape='false' @open="openFn" width="80vw"
      class="materialPurchase-add">
      <div slot="title" class="dialog-title dialog-top">
        <div class="dialog-detail">
          <span class="detail">{{ $lang('申购物料') }}</span>
        </div>
        <img class="dialog-close" src="@/assets/images/close.png" alt="" @click="close">
      </div>
      <div class="dialog-content" ref="dialogContent">
        <div class="table-box" ref="tableWrapper" style="overflow:auto">
          <el-table
            ref="table"
            v-loading="tableLoading"
            border
            :load="loadMore"
            :height="380"
            :data="tableList"
            @scroll="handleScroll"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="materialName" :label="$lang('物料信息')" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <div class="materialName-box">
                  <img v-if="row.materialPictures" class="materialPictures-img" @click="preViewImg(row)"  :src="row.materialPictures" alt="">
                  <span>{{ row.materialName || '--' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="materialCode" :label="$lang('物料编码')" show-overflow-tooltip :width="150"></el-table-column>
            <el-table-column prop="materialUnitPrice" :label="$lang('物料单价')" show-overflow-tooltip :width="150"></el-table-column>
            <el-table-column prop="purchaseCount" :width="200" class="number-input">
              <template slot="header">
                {{ $lang('物料数量') }}
                <el-tooltip placement="top">
                  <div slot="content">{{ $lang('提示：物料数量只能为最小采购数的整数倍') }}</div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                <el-input-number
                  v-model.trim="row.purchaseCount"
                  :min="row.minPurchaseQuantityCount"
                  :max="999999"
                  :step="row.minPurchaseQuantityCount"
                  :step-strictly="true"
                  @input="val => val && val.toString().replace(/[^\d]/g, '')"
                  @change="calculateCost"
                >
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="minPurchaseQuantityCount" :label="$lang('最小采购数量')" show-overflow-tooltip :width="150"></el-table-column>
            <el-table-column prop="decr" :label="$lang('物料说明')" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.decr || '--' }}
              </template>
            </el-table-column>
            <!-- 表格列定义 -->
          </el-table>
          <div v-if="moreLoading" class="more-data">
            {{ $lang('数据加载中') }}...
          </div>
          <div class="spam-total">
            <span>{{ $lang('合计') }}：￥</span>
            <span>{{ purchaseMoney | pricefmtMoney }}</span>
          </div>
        </div>
        <div class="address-book">
          <el-form :model="form" :rules="rules" ref="form" class="form-box" label-suffix=":" label-position="top">
            <el-form-item prop="userSender">
              <template slot="label">
                <label style="line-height: 32px; color: #666">{{ $lang('邮寄地址') }}：</label>
                <el-tooltip effect="dark" placement="top-start">
                  <span class="tooltip-click">?</span>
                  <div slot="content">{{ $lang('物料邮寄地址 ，支持在寄件地址簿中维护') }}<br /></div>
                </el-tooltip>
              </template>
              <el-input :placeholder="$lang('请选择寄件人信息')" readonly :value="form.userSender"
                style="width: 100% !important">
                <template slot="suffix">
                  <i class="iconfont icondizhibao pointer" @click="open(1)"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$lang('付款方式')" prop="payType">
              <Base-Select v-model="form.payType" :dic="payTypeList" :placeholder="$lang('请选择付款方式')" :disabled="true"
                :props="{ label: 'name', value: 'code' }"></Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('备注')" prop="remark">
              <el-input type="textarea" :placeholder="$lang('请输入备注信息')" v-model="form.remark" maxlength="200" show-word-limit>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">{{ $lang('取消') }}</el-button>
        <el-button type="primary" :loading="saveLoading" :disabled="selection.length === 0" @click="save">{{ $lang('去申请') }}</el-button>
      </div>
    </el-dialog>
    <!-- 地址簿 -->
    <AddressBook v-model="addrBook" :selectType="1" @single-row-select="singleRowSelect" ref="address"></AddressBook>
    <!-- 图片预览 -->
    <ImageView v-if="preViewVisible" :initialIndex='preViewIndex' :urlList='urlList' :onClose='preViewClose' :zIndex="99999" />
  </div>
</template>

<script>
import ImageView from '@/components/ImageView.vue'
import AddressBook from '../../place-order/single-order/AddressBook'
import { RESPONSE_SUCCESS } from '@constants'
import { getDefaultAddress, getMaterialPage, materialGrantAdd, granPayType } from '@api/module/customer'
import { RULES } from '@utils/rules'
import { payTypeList } from '@utils/const'
import { pricefmt } from '@utils/util'

export default {
  name: 'Add',
  components: {
    AddressBook,
    ImageView,
  },
  filters: {
    pricefmtMoney(val) {
      return pricefmt(val)
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableList: [], // 初始表格数据
      saveLoading: false,
      tableLoading: false,
      moreLoading: false,
      current: 1, // 当前页码
      size: 50,
      hasMore: true, // 是否还有更多数据
      addrBook: false,
      preViewVisible: false, // 图片预览弹窗
      preViewIndex: 0, // 当前预览设置
      urlList: [], // 预览图片地址
      selection: [], // 选择的数据
      purchaseMoney: '', // 选中的总费用
      payTypeList,
      userInfo: '',
      form: {
        userSender: '',
        consignee: '', // 收货人姓名
        phone: '',
        address: '',
        area: '',
        city: '',
        province: '',
        grantDetailList: [],
        payType: '',
        remark: '',
      },
      rules: {
        payType: [RULES.requiredSelect],
        userSender: [RULES.requiredSelect],
      },
    }
  },
  computed: {
    listOpt() {
      return {
        fixHeight: 90,
        selection: true,
        menu: false,
        index: false,
        showSummary: true,
        column: [
          {
            label: '物料信息',
            prop: 'materialName',
            slot: true
          },
          {
            label: '物料编码',
            prop: 'materialCode',
          },
          {
            label: '物料单价',
            prop: 'materialUnitPrice',
          },
          {
            label: '物料数量',
            prop: 'purchaseCount',
            slot: true,
          },
          {
            label: '物料说明',
            prop: 'decr',
          },
        ]
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          const tableBodyWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper')
          tableBodyWrapper.addEventListener('scroll', this.handleScroll)
        })
      }
    }
  },
  methods: {
    openFn() {
      this.getDefaultAddress()
      this.getGranPayType()
      this.tableLoading = true
      this.loadMore()
    },
    // 物料申购付款方式
    // 如果接口返回错误，默认1：货到付款
    async getGranPayType() {
      try {
        const { code, data, msg } = await granPayType()
        if (code === RESPONSE_SUCCESS) {
          this.form.payType = data || 1
        } else {
          this.form.payType = 1
          this.$message.error(msg)
        }
      } catch (err) {
        this.form.payType = 1
      }
    },
    // 监听滚动条位置
    handleScroll(event) {
      const target = event.target
      if (target.scrollHeight - target.scrollTop > target.clientHeight - 10 && this.hasMore && !this.moreLoading) {
        this.current++
        this.moreLoading = true
        this.loadMore()
      }
    },
    // 加载更多
    async loadMore() {
      // 这里是请求接口获取下一页数据的方法
      try {
        const params = {
          current: this.current,
          size: this.size,
        }
        const res = await getMaterialPage(params)
        this.tableLoading = false
        this.moreLoading = false
        if (res.code === RESPONSE_SUCCESS) {
          const { records } = res.data
          if (records.length > 0) {
            const newData = records.map(item => {
              return {
                ...item,
                purchaseCount: item.minPurchaseQuantityCount,
              }
            })
            this.tableList = [...this.tableList, ...newData]
            if (this.tableList.length === res.data.total) {
              this.hasMore = false
            }
          } else {
            this.hasMore = false // 如果返回的数据为空，则表示没有更多数据了
          }
        }
      } catch (err) {
        this.tableLoading = false
        this.moreLoading = false
      }
    },
    handleSelectionChange(val) {
      this.selection = val
      this.calculateCost(val)
    },
    handleSelectAll(val) {
      this.selection = val
      this.calculateCost(val)
    },
    // 计算勾选的物料费用
    calculateCost () {
      let purchaseMoney = 0
      this.selection.forEach(item => {
        if (+item.purchaseCount) {
          purchaseMoney += (+item.purchaseCount * +item.materialUnitPrice)
        }
      })
      this.purchaseMoney = +purchaseMoney
    },
    // 预览
    preViewImg(item) {
      const { materialPictures } = item
      if (materialPictures && materialPictures.length > 0) {
        this.urlList = [materialPictures]
        this.preViewVisible = true
      }
    },
    /**
     * @description: 关闭预览
     */
    preViewClose() {
      this.preViewIndex = 0
      this.preViewVisible = false
    },
    // 获取默认地址
    async getDefaultAddress() {
      const param = {
        type: 1,
      }
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        this.$nextTick(() => {
          if (data) {
            this.setForm(data)
          }
        })
      } else {
        this.$message.error(msg)
      }
    },
    setForm(data) {
      this.userInfo = data || ''
      data.provinceName = this.newStr(data.provinceName)
      data.cityName = this.newStr(data.cityName)
      data.areaName = this.newStr(data.areaName)
      const { name, mobile, provinceName, cityName, areaName, street } = data
      this.form.userSender = `${name}/${mobile}/${provinceName}${cityName}${areaName}${street || ''}${data.buildingNo || ''}${data.buildingFloor || ''}${data.roomNumber || ''}`
      this.form.consignee = name || ''
      this.form.phone = mobile || ''
      this.form.province = provinceName || ''
      this.form.city = cityName || ''
      this.form.area = areaName || ''
      this.form.address = street || ''
      this.$refs.form.validateField('userSender')
    },
    // 字符串截取
    newStr(str) {
      if (str != null && str.indexOf('（') > -1) {
        return str.substring(0, str.indexOf('（'))
      } else {
        return str
      }
    },
    // 打开地址簿
    open() {
      this.addrBook = true
      this.$refs.address.updateBtnStauts(this.userInfo)
    },
    // 地址簿选择
    singleRowSelect(data, type) {
      this.setForm(data)
    },
    // 保存
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.form.grantDetailList = [...this.selection]
            this.saveLoading = true
            const res = await materialGrantAdd(this.form)
            this.saveLoading = false
            if (res.code === RESPONSE_SUCCESS) {
              this.$message.success(this.$lang('申购成功'))
              this.close()
              this.$emit('searchFun', 1)
            } else {
              this.$message.error(res.msg)
            }
          } catch (err) {
            this.saveLoading = false
          }
        }
      })
    },
    // 取消
    close() {
      this.removeScrollFn()
      this.$emit('update:dialogVisible', false)
      this.initData()
    },
    // 初始化数据
    initData() {
      this.form = {
        consignee: '', // 收货人姓名
        phone: '',
        address: '',
        area: '',
        city: '',
        province: '',
        grantDetailList: [],
      }
      this.current = 1
      this.hasMore = true
      this.moreLoading = false
      this.tableLoading = false
      this.$refs.form.resetFields()
      this.$refs.table.clearSelection()
      this.selection = []
      this.tableList = []
      this.purchaseMoney = 0
      this.$refs.dialogContent.scrollTop = 0
    },
    // 关闭弹窗前移除事件监听器
    removeScrollFn() {
      const tableBodyWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper')
      tableBodyWrapper.removeEventListener('scroll', this.handleScroll)
    }
  },
}
</script>

<style lang="scss" scoped>
/* 保证el-table所在的div可以滚动 */
div[ref="tableWrapper"] {
  width: 100%;
}

.dialog-top {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .dialog-detail {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .detail {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFangSC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      font-weight: 600;
    }
  }

  .dialog-close {
    width: 16px;
    height: 16px;
    display: inline-block;
    cursor: pointer;
  }
}

.dialog-content {
  height: 80vh;
  overflow-y: scroll;
  padding-right: 10px;

  .address-book {
    margin-left: 10px;
  }

  .tooltip-click {
    cursor: pointer;
    border-radius: 10px;
    color: #999999;
    display: inline-block;
    line-height: 18px;
    width: 18px;
    height: 18px;
    font-weight: 800;
    text-align: center;
    border: 1px solid #999999;
    box-sizing: border-box;
  }
}

.spam-total {
  width: 100%;
  height: 60px;
  line-height: 60px;
  border: 1px solid #e8e8e8;
  border-top: none;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  color: #E60000;
  font-weight: 900;
  padding-right: 24px;

  span:nth-child(1) {
    font-size: 16px;
  }
  span:nth-child(2) {
    font-size: 20px;
  }
}

.more-data {
  width: 100%;
  text-align: center;
  padding: 10px;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  box-sizing: border-box;
}
::v-deep {
  // .el-table {
  //   height: auto !important;
  //   min-height: 200px;
  //   max-height: 350px;
  // }
  .el-form-item__label {
    padding: 0;
  }
  .el-dialog__body {
    box-sizing: border-box;
    height: calc(100vh - 260px);
    overflow: auto;
  }
}

.table-box {
  margin-bottom: 18px;

  .materialName-box {
    padding: 10px;
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      cursor: pointer;
      margin-right: 10px;
    }
  }
}
</style>
